<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <vip-level-bank-account-table></vip-level-bank-account-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import vipLevelBankAccountTable from './VIPLevelBankAccountTable.vue'

  export default {
    name: 'vipLevelBankAccount',
    components: {vipLevelBankAccountTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelBankAccount.vue